// Bored George - Bundle App
// File: bundle-product.js

const BoredGeorgeBundle = {
  config: {
    bundlePrice: 30200,
    singlePrice: 18900,
    savings: 7500,
    bundleTags: ['sunglasses', 'blue light'], // products with ANY of these tags can appear in the bundle
    excludeTag: 'outlet',
  },

  init() {
    this.bindButtons();
  },

  bindButtons() {
    const buyTwoBtn = document.getElementById('bg-buy-two');
    const buyOneBtn = document.getElementById('bg-buy-one');

    if (buyTwoBtn) {
      buyTwoBtn.addEventListener('click', () => this.openModal());
    }

    if (buyOneBtn) {
      buyOneBtn.addEventListener('click', () => this.buyOne());
    }
  },

  buyOne() {
    const variantId = document.querySelector('[name="id"]').value;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(() => {
      if (typeof window.unicornOpenCart === 'function') {
        window.unicornOpenCart();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(err => console.error('Error adding to cart:', err));
  },

  openModal() {
    this.fetchProducts();
    const modal = document.getElementById('bg-bundle-modal');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        this.closeModal();
      }
    });
  },

  closeModal() {
    document.getElementById('bg-bundle-modal').style.display = 'none';
    document.body.style.overflow = '';
  },
};

document.addEventListener('DOMContentLoaded', () => BoredGeorgeBundle.init());

// ===== Variant helpers (size dropdown) =====
Object.assign(BoredGeorgeBundle, {

  // Renders a size dropdown only when there's a real choice (>1 available variant)
  buildVariantSelector(availableVariants) {
    if (availableVariants.length <= 1) return '';
    const opts = availableVariants
      .map(v => `<option value="${v.id}">${v.title}</option>`)
      .join('');
    return `<select class="bg-variant-select">${opts}</select>`;
  },

  // Reads the chosen variant from a card (the dropdown if present, else the only variant)
  resolveChosenVariant(card, product, fallbackVariant) {
    const selectEl = card.querySelector('.bg-variant-select');
    const chosenId = selectEl ? selectEl.value : fallbackVariant.id;
    const chosen = product.variants.find(v => String(v.id) === String(chosenId)) || fallbackVariant;
    const title = (chosen.title && chosen.title !== 'Default Title')
      ? `${product.title} — ${chosen.title}`
      : product.title;
    return { id: chosen.id, title };
  },

});

// Product fetching - adds to BoredGeorgeBundle
Object.assign(BoredGeorgeBundle, {

  fetchProducts() {
    const modalGrid = document.getElementById('bg-modal-grid');
    modalGrid.innerHTML = '<p class="bg-loading">Loading styles...</p>';

    fetch('/collections/buy-2-save-75/products.json?limit=250')
      .then(res => res.json())
      .then(data => {
  const sunglasses = data.products.filter(product => {
    const tags = product.tags.map(t => t.toLowerCase());
    const hasBundleTag = tags.some(t => this.config.bundleTags.some(bt => t.includes(bt)));
    const hasOutletTag = tags.some(t => t.includes(this.config.excludeTag));
    return hasBundleTag && !hasOutletTag;
  });

        if (sunglasses.length === 0) {
          modalGrid.innerHTML = '<p class="bg-loading">No styles found.</p>';
          return;
        }

        this.renderProducts(sunglasses);
      })
      .catch(err => {
        console.error('Error fetching products:', err);
        modalGrid.innerHTML = '<p class="bg-loading">Something went wrong. Please try again.</p>';
      });
  },

  renderProducts(products) {
    const currentProductId = parseInt(document.getElementById('bg-buy-two').dataset.productId);
    const modalGrid = document.getElementById('bg-modal-grid');
    modalGrid.innerHTML = '';

    products.forEach(product => {
      if (product.id === currentProductId) return; // exclude current product

      // Only offer available variants; skip the style entirely if all sold out
      const availableVariants = product.variants.filter(v => v.available);
      if (availableVariants.length === 0) return;

      const baseVariant = availableVariants[0];
      const image = product.images[0] ? product.images[0].src : '';
      const price = parseFloat(baseVariant.price).toFixed(2);
      const bundlePrice = (parseFloat(baseVariant.price) - 75).toFixed(2);

      const card = document.createElement('div');
      card.className = 'bg-product-card';
      card.dataset.productTitle = product.title;
      card.innerHTML = `
        <img src="${image}" alt="${product.title}" class="bg-product-image" />
        <div class="bg-product-info">
          <p class="bg-product-title">${product.title}</p>
          <p class="bg-product-price"><span class="bg-price-was">$${price}</span> <span class="bg-price-now">$${bundlePrice}</span></p>
          ${this.buildVariantSelector(availableVariants)}
        </div>
        <button class="bg-select-btn">Select</button>
      `;

      card.querySelector('.bg-select-btn').addEventListener('click', () => {
        const chosen = this.resolveChosenVariant(card, product, baseVariant);
        this.selectSecondPair(chosen.id, chosen.title);
      });

      modalGrid.appendChild(card);
    });
  },

});
// Cart logic - adds to BoredGeorgeBundle
Object.assign(BoredGeorgeBundle, {

  selectSecondPair(secondVariantId, secondProductTitle) {
    const firstVariantId = document.querySelector('[name="id"]').value;
    this.addBundleToCart(firstVariantId, secondVariantId);
  },

  addBundleToCart(firstVariantId, secondVariantId) {
    this.closeModal();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: parseInt(firstVariantId), quantity: 1 },
          { id: parseInt(secondVariantId), quantity: 1 }
        ]
      })
    })
    .then(res => res.json())
    .then(() => {
      if (typeof window.unicornOpenCart === 'function') {
        window.unicornOpenCart();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(err => {
      console.error('Bundle cart error:', err);
    });
  },

});
// Hide/show bundle based on selected variant availability
Object.assign(BoredGeorgeBundle, {

  initVariantWatcher() {
    const bundleCard = document.getElementById('bg-buy-two');
    if (!bundleCard) return;

    const variantInput = document.querySelector('[name="id"]');
    if (!variantInput) return;

    this.updateBundleVisibility(variantInput.value);

    const observer = new MutationObserver(() => {
      this.updateBundleVisibility(variantInput.value);
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    variantInput.addEventListener('change', () => {
      this.updateBundleVisibility(variantInput.value);
    });
  },

  updateBundleVisibility(variantId) {
    const bundleCard = document.getElementById('bg-buy-two');
    if (!bundleCard || !variantId) return;

    const availabilityMap = {};
    (bundleCard.dataset.variantsAvailability || '').split(',').forEach(pair => {
      const [id, avail] = pair.split(':');
      availabilityMap[id] = avail === 'true';
    });

    const isAvailable = availabilityMap[variantId];
    bundleCard.style.display = isAvailable ? '' : 'none';
  },

});

document.addEventListener('DOMContentLoaded', () => BoredGeorgeBundle.initVariantWatcher());